/**
 * SINGLE Y.JS INSTANCE MODULE
 * 
 * 🔥 CRITICAL FIX: Prevents "Yjs was already imported" constructor conflicts
 * 
 * Problem: 44 separate Y.js imports were creating multiple instances,
 * breaking internal constructor checks and causing splice/corruption errors.
 * 
 * Solution: Single Y.js import/export point for the entire application.
 * 
 * Reference: https://github.com/yjs/yjs/issues/438
 * "Yjs was already imported. This breaks constructor checks and will lead to issues!"
 */

// Single Y.js import for the entire application
import * as Y from 'yjs';

// Re-export ALL Y.js functionality exactly as it is
export * from 'yjs';

// Export the Y namespace for `import * as Y` compatibility
export { Y };
export default Y;
